import React from 'react';
import PropTypes from 'prop-types';
import Switch from '@mui/material/Switch';

const DetailsCard = ({ cardData, itemsPerColumn, onEdit, onToggle }) => {
  const columnsData = [];
  for (let index = 0; index < cardData.length; index += itemsPerColumn) {
    columnsData.push(cardData.slice(index, index + itemsPerColumn));
  }
  if (columnsData.length === 1 || columnsData.length === 2) {
    columnsData.push([]);
  }

  /**
   * Render the toggle switch option if toggle is enabled
   *
   * @param {Object} item
   */
  const renderToggleSwitch = (item) => {
    return (
      <Switch
        checked={item.data}
        onChange={() => {
          onToggle(item.rawLabel, !item.data);
        }}
        color="primary"
      />
    );
  };

  /**
   * Render the value of the key-value pair if not toggle-able
   *
   * @param {Object} item
   */
  const renderDataValue = (item) => {
    return (
      <>
        <p
          className={'details-card-row-data ' + (item.editable ? 'active' : '')}
          onClick={() => {
            if (item.editable) {
              onEdit(item.rawLabel ? item.rawLabel : item.label);
            }
          }}
        >
          {item.data || '--'}
        </p>
      </>
    );
  };

  return (
    <div className="details-card-details-container">
      <div className="details-card-column-holder">
        {columnsData.map((group, groupIndex) => {
          return (
            <div key={`column-${groupIndex}`} className="details-card-column">
              {group.map((item, itemIndex) => {
                return (
                  <div
                    className={`details-card-row ${
                      item.underlineBorder ? 'details-card-row-underline' : ''
                    }`}
                    key={`${item.label} -${itemIndex}`}
                  >
                    <h1 className="details-card-row-label">{item.label}</h1>
                    {item.toggleable ? renderToggleSwitch(item) : renderDataValue(item)}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

DetailsCard.propTypes = {
  cardData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onEdit: PropTypes.func,
  onToggle: PropTypes.func,
  'cardData.map': PropTypes.func,
  itemsPerColumn: PropTypes.number,
};

DetailsCard.defaultProps = {
  itemsPerColumn: 4,
};

export default DetailsCard;
